import { z } from "zod";

import {
  CommercialMeterKey,
  CommercialUsageRecoveryAction,
  type CommercialUsageLimitRejection,
} from "./types";

const commercialUsageLimitDecisionSchema = z.object({
  code: z.literal("COMMERCIAL_USAGE_LIMIT_REACHED"),
  meter_key: z.enum(Object.values(CommercialMeterKey)),
  recovery_actions: z.array(z.enum(Object.values(CommercialUsageRecoveryAction))).min(1),
});

const commercialUsageLimitRejectionSchema = commercialUsageLimitDecisionSchema.extend({
  accepted: z.literal(false),
});

const commercialUsageLimitAdvisorySchema = commercialUsageLimitDecisionSchema.extend({
  accepted: z.literal(true),
});

const adaptCommercialUsageLimitDecision = (
  parsed:
    | z.infer<typeof commercialUsageLimitRejectionSchema>
    | z.infer<typeof commercialUsageLimitAdvisorySchema>
): CommercialUsageLimitRejection => ({
  accepted: parsed.accepted,
  code: parsed.code,
  meterKey: parsed.meter_key,
  recoveryActions: parsed.recovery_actions,
});

export const parseCommercialUsageLimitRejection = (
  value: unknown
): CommercialUsageLimitRejection | null => {
  const parsed = commercialUsageLimitRejectionSchema.safeParse(value);
  if (!parsed.success) {
    return null;
  }

  return adaptCommercialUsageLimitDecision(parsed.data);
};

export const parseCommercialUsageLimitAdvisory = (
  value: unknown
): CommercialUsageLimitRejection | null => {
  const parsed = commercialUsageLimitAdvisorySchema.safeParse(value);
  if (!parsed.success) {
    return null;
  }

  return adaptCommercialUsageLimitDecision(parsed.data);
};
